export default __webpack_public_path__ + "static/media/kappa.376f51e9.jpg";